<template>
  <div>
    <ul class="mt60">
      <li v-for="(item, keys) in stepOptions.steps" :key="keys" class="inline-block mr5">
        <i v-show="item.name === status" class="circle"></i>
        <span :style="getWid" class="line grey-bg" :class="{'green-bg': item.name < status, 'trans-bg' : keys === stepOptions.steps.length - 1, 'topBtmLeft' : keys === 0, 'topBtmRight' : keys === stepOptions.steps.length - 2}"></span>
        <div class="desc" @click="curStep(item.name, item.value)">
          {{ item.value }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Steps',
  props: {
    tag: {
      type: String,
      default: () => {
        return '';
      }
    },
    stepOptions: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      getWid: {
        width: ''
      },
      status: 3
    };
  },
  mounted() {
    this.status = this.stepOptions.active;
    this.getWidth();
  },
  methods: {
    getWidth() {
      this.getWid.width = parseInt(400 / (this.stepOptions.steps.length - 1)) + 'px';
    },
    curStep(name, val) {
      this.status = name;
      this.$emit('actives', { tag: this.tag, value: val });
    }
  }
};
</script>

<style lang="scss" scoped>

.desc {
  position: relative;
  right:5px;
  width:50%;
  cursor: pointer;
}
.circle {
    width: 20px;
    height: 20px;
    background:white;
    border-radius:50%;
    border:2px solid #409EFF;
    position: absolute;
    top:-4px;
    left:-10px;
}
.line {
    display: inline-block;
    height: 6px;
    margin-bottom: 5px;
}
.topBtmLeft{
  border-top-left-radius:24px;
  border-bottom-left-radius:24px;
}
.topBtmRight{
  border-top-right-radius:24px;
  border-bottom-right-radius:24px;
}
.inline-block{
  display: inline-block;
  position: relative;
}
.mt60 {
    margin: 20px 0;
}
i.red-bg {
    background-color: red;
}
.grey-bg {
    background-color: #E4E7ED;
}
.green-bg {
    background-color: #409EFF;
}
.trans-bg{
  background-color: transparent;
}
.fs8 {
    font-size: 8px;
}
</style>
